import styled from "styled-components";
import reactDomServer from "react-dom/server";
import { FilePond, registerPlugin } from "react-filepond";
import { useCookies } from "react-cookie";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

export type PropsType = any;

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

const WrapFilePond = styled.div<any>`
   ${({ css }) => css}
`;
// Our app
export default function FileInput(props: PropsType) {
   const [cookies]: any = useCookies(["cookie-name"]);
   const host = cookies.development ? "http://localhost:8024" : "http://art-map.co.kr:8024";
   const baseUri = `${host}/public/api/v2`;
   const server = {
      load: `https://art-map.co.kr/write/getFile.php?uri=`,
      fetch: `https://art-map.co.kr/write/getFile.php?uri=`,
      timeout: 7000,
      process: {
         url: `https://art-map.co.kr/upload.php?target=exhibition`,
         method: "POST",
         withCredentials: true,
         onload: props.onComplete,
      },
   };
   //`여기에 ${props.name}를 Drag & Drop 또는 <span class="filepond--label-action">클릭</span>`
   return (
      <WrapFilePond style={props.style} css={props.css}>
         <FilePond
            files={props.files ? props.files : []}
            allowMultiple={true}
            maxFiles={5}
            maxFileSize={"30MB"}
            server={server as any}
            name="file"
            labelIdle={reactDomServer.renderToStaticMarkup(props.children).toString()}
         />
      </WrapFilePond>
   );
}
